import styled from "styled-components";
import { MOBILE_WIDTH, TABLET_WIDTH } from "datastake-daf/src/constants/Style";

const style = styled.div`
  font-family: Outfit;

  .btns {
    display: flex;
    gap: 12px;
  }

  .d-container {
    width: 80vw;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 1440px) {
      width: 85vw;
    }

    @media (${TABLET_WIDTH}) {
      width: calc(100vw - 4.6rem);
    }
  }

  .flex-c {
    display: flex;
    flex-direction: column;
  }

  .jus-c {
    justify-content: center;
  }

  .d-navbar {
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    position: fixed;
    background-color: white;
    z-index: 1000;
    width: 100%;
    height: 80px;

    @media (${TABLET_WIDTH}) {
      height: 72px;
    }

    @media (${MOBILE_WIDTH}) {
      height: 5.12rem;
    }

    .main-cont {
      display: flex;
      padding: 20px 0px;

      @media (${MOBILE_WIDTH}) {
        padding: 1.6rem 0;
      }

      .left {
        flex: 1;

        img {
          cursor: pointer;
          width: 128px;

          @media (${MOBILE_WIDTH}) {
            width: 10.24rem;
          }
        }
      }

      .right {
        display: flex;
        gap: 3rem;

        .ant-btn {
          font-size: 14px;
          padding: 6px 0;
          text-align: center;
          width: 70px;

          @media (${MOBILE_WIDTH}) {
            padding: 3px 0;
          }
        }

        @media (max-width: 1070px) {
          gap: 2rem;
        }
      }
    }
  }

  &.bordered {
    .d-navbar {
      position: relative;
      box-shadow: unset;
      border-bottom: 1px solid var(--base-gray-40);
    }
  }

  .tazama-extra {
    &.mobile {
      display: none;
    }

    @media (${MOBILE_WIDTH}) {
      &.mobile {
        display: flex;
      }

      &.desktop {
        display: none;
      }
    }

    .ant-btn {
      width: 90px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;

      &.w-100 {
        width: 100% !important;
      }

      span {
        margin: 0 auto;
      }
    }

    .nav-extra {
      position: fixed;
      top: 0;
      left: 0;
      height: 100dvh;
      width: 100%;
      background: white;
      margin-left: -100%;
      transition: 0.4s margin-left;

      &.toggled {
        margin-left: 0;
      }
    }
  }
`;

export default style;
